import { eQueueActionTypeDefine } from "../../action-types/queue/IQueueActions";
import { generateActions } from "../generateActions";

export const queueActions = {
    ...generateActions(eQueueActionTypeDefine, "QUEUE"),
};
